module.exports = __webpack_public_path__ + "img/default-dashboard.9cc27f59.png";